import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export interface GeneralDto {
  loading: boolean;
}

export const setLoading = createAsyncThunk(
  "general/setLoading",
  async (value: boolean) => {
    return { value: value };
  }
);
const initialState: GeneralDto = {
  loading: false,
};

export const general = createSlice({
  name: "general",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setLoading.fulfilled, (state, { payload }) => {
      state.loading = payload.value;
    });
  },
});

export default general.reducer;
